<template>
  <div class="condition_query">
    <h1>{{ $t("tool.querytitle") }}</h1>
    <div class="form_com">
      <el-row class="search_com">
        <el-col :span="6" class="port_com">
          <span>{{ $t("tool.model") }}</span>
          <el-input placeholder v-model="planeCodes" clearable></el-input>
        </el-col>
        <el-col :span="8" class="port_com">
          <span>{{ $t("tool.aircraftType") }}</span>
          <el-select v-model="plane_type" clearable @change="planeChange">
            <el-option label="Wide Body" value="W"></el-option>
            <el-option label="Narrow Body" value="N"></el-option>
            <el-option label="All" value></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="query" @click="planeQuery">{{ $t("home.book") }}</el-button>
        </el-col>
      </el-row>
      <el-table class="table_com" :data="planeData" stripe style="width: 100%">
        <el-table-column
          prop="genType"
          label="Model Code"
          width="143"
        ></el-table-column>
        <el-table-column
          prop="acrftCode"
          label="Model"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="Full Name"
          width="288"
        ></el-table-column>
        <el-table-column
          prop="bodyType"
          label="Wide Body Narrow Body"
          width="156"
        ></el-table-column>
        <el-table-column
          prop="range"
          label="Voyage"
          width="120"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/tool/tool.css";
</style>
<script type="babel">
import YC_REQUEST_HANDLER from "@/api/request.js";

export default {
    data: function() {
        return {
            planeCode: "",
            plane_type: "",
            planeData: [
                {
                    bodyType: "—",
                    acrftCode: "—",
                    name: "—",
                    range: "—",
                    genType: "—"
                }
            ]
        };
    },
    computed: {
        planeCodes: {
            get: function() {
                return this.planeCode;
            },
            set: function(val) {
                this.planeCode = val.toUpperCase();
            }
        }
    },
    methods: {
        planeChange: function(e) {
            this.bodyType = e;
        },
        planeQuery: function() {
            var vm = this;
            if (vm.planeCode || vm.plane_type) {
                var params = {
                    genType: vm.planeCode,
                    bodyType: vm.plane_type
                };
                var url = "/api/freight/tool/aircraft/list";
                var successCallBack = function(res) {
                    vm.planeData = res.aircraftList ? res.aircraftList : [];
                };
                var failCallBack = function(errcode, errmessage) {
                    vm.$bus.emit("common-error-handler", errmessage);
                };
                YC_REQUEST_HANDLER.postQuery( url, params, successCallBack, failCallBack);
            } else if (!vm.planeCode && !vm.plane_type) {
                vm.$bus.emit("commmon-notification", null, "Model or model type cannot be empty");
            }
        }
    }
};
</script>
